import { render } from "./IDRJobDetail.vue?vue&type=template&id=fa4eeb28&scoped=true"
import script from "./IDRJobDetail.vue?vue&type=script&lang=js"
export * from "./IDRJobDetail.vue?vue&type=script&lang=js"

import "./IDRJobDetail.vue?vue&type=style&index=0&id=fa4eeb28&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4eeb28"]])

export default __exports__